import consola from 'consola'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin(() => {
  // Configure consola for client-side
  if (typeof window !== 'undefined') {
    // Get environment from runtime config
    const runtimeConfig = useRuntimeConfig()
    const isDev = process.dev || runtimeConfig.public.stcsEnv === 'dev_local' || runtimeConfig.public.stcsEnv === 'develop'

    // Set log level based on environment
    if (isDev) {
      // In development, show all logs including debug
      consola.level = 5 // TRACE level (shows everything)
    } else {
      // In production, show info and above (no debug logs)
      consola.level = 3 // INFO level
    }

    // Optional: Add custom styling for better visibility in browser console
    consola.options.formatOptions = {
      colors: true,
      date: true,
      compact: false,
    }

    // Make consola globally accessible for debugging
    if (typeof window !== 'undefined') {
      window.consola = consola

      // Add utility functions to window for easy debugging
      window.enableDebugLogs = () => {
        consola.level = 5
        consola.success('🚀 Debug logging enabled!')
      }

      window.disableDebugLogs = () => {
        consola.level = 3
        consola.info('🔇 Debug logging disabled.')
      }

      // Show current log level
      window.getLogLevel = () => {
        const levels: Record<number, string> = {
          0: 'SILENT',
          1: 'FATAL',
          2: 'ERROR',
          3: 'WARN/INFO',
          4: 'LOG',
          5: 'DEBUG/TRACE',
        }
        consola.info(`Current log level: ${levels[consola.level] || 'UNKNOWN'} (${consola.level})`)
        return consola.level
      }
    }

    // Log the current configuration
    consola.info('📋 Consola configured for client-side:', {
      level: consola.level,
      isDev,
      environment: runtimeConfig.public.stcsEnv,
    })
  }
})

// Extend global window interface for TypeScript
declare global {
  interface Window {
    consola: typeof consola
    enableDebugLogs: () => void
    disableDebugLogs: () => void
    getLogLevel: () => number
  }
}
